import { sendInviteAcceptedEmail } from './inviteEmailService';
import { shouldAttemptInviteEmail } from './memberInviteLogic';

/**
 * After a successful accept: optionally notify the trainer by email.
 * Never throws — accept UX must not depend on Resend.
 */
export async function notifyTrainerOfInviteAccepted(params: {
  trainerId: string;
  relationshipId: string;
  appUrl?: string;
}): Promise<void> {
  if (!shouldAttemptInviteEmail()) return;
  try {
    await sendInviteAcceptedEmail(params);
  } catch (err) {
    console.warn('[Invite accepted email] could not notify trainer:', err);
  }
}
